import { Component } from 'react';
import BottomNav from './BottomNav';
import TopNav from './TopNav';

class Nav extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="nav-fixed">
                <TopNav />
                <BottomNav />
            </div>
         );
    }
}
 
export default Nav;